import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import PointForm from '../form/point'
import {TableFurnitureWrapper} from './component/table/furniture'
import {TableServicesWrapper} from './component/table/service'
import {TableMachineWrapper} from './component/table/machine'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
const FurnitureTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('MOBILIARIO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Mobiliario</Tab>
          )}
          {isAllowed('ASIGMAQUINARIA/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Asignar maquinaria</Tab>
          )}
          {isAllowed('ASIGSERVICIO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Asignar servicio</Tab>
          )}
        </TabList>
        <TabPanel>
          <PointForm />
        </TabPanel>
        {isAllowed('MOBILIARIO/ACCESO') && (
          <TabPanel>
            <TableFurnitureWrapper />
          </TabPanel>
        )}
        {isAllowed('ASIGMAQUINARIA/ACCESO') && (
          <TabPanel>
            <TableMachineWrapper />
          </TabPanel>
        )}
        {isAllowed('ASIGSERVICIO/ACCESO') && (
          <TabPanel>
            <TableServicesWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default FurnitureTab
